module.exports = __webpack_public_path__ + "static/img/2.399f0bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/sp/2.png
// module id = LRIl
// module chunks = 0